import axiosInstance from "services/AxiosInstance";

import { Accounts } from "../components/userTable/userTable.types";

export const removeUserRole = async ({ userId, accountId, ...params }: Accounts) => {
  const response = await axiosInstance.delete(`/accounts/${accountId}/users/${userId}`, { params });
  return response.data;
};
